<mat-toolbar [class.mat-elevation-z4]="true" [ngClass]="{ mobile: breakpoint }" class="topnavbar-project"
  color="primary">
  <!--Page Title-->
  <div class="container-buttons">
    @if (breakpoint) {
    <app-navigation-brand-logo [brand]="brand" [collapse]="false" class="brandLogo"></app-navigation-brand-logo>
    }
    <div class="container-breadcrumb-topnavbar">
      @if(!breakpoint) {
      <app-topnavbar-breadcrumb [title]="title"></app-topnavbar-breadcrumb>
      }
    </div>
    <ng-content></ng-content>
    @if (breakpoint) {
    <app-notifications-bell></app-notifications-bell>
    <topnavbar-profile [link]="link"></topnavbar-profile>
    }
  </div>
</mat-toolbar>